import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ViewportService} from '../../../services/viewport.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';


@Component({
    selector: 'flight-deals',
    templateUrl: './flight-deals.component.html',
    styleUrls: ['./flight-deals.component.scss']
})
export class FlightDealsComponent implements OnInit, OnDestroy {
    numVisible: number;
    private destroy$ = new Subject<void>();

    flightDeals = [
        { image: 'assets/images/flight-deals/Deal1.webp', route: 'Dallas → Italy', currentPrice: 399, originalPrice: 1210, discount: 67 },
        { image: 'assets/images/flight-deals/Deal2.webp', route: 'Chicago → Greece', currentPrice: 382, originalPrice: 1140, discount: 68 },
        { image: 'assets/images/flight-deals/Deal3.webp', route: 'Los Angeles → Tokyo', currentPrice: 499, originalPrice: 1100, discount: 55 },
        { image: 'assets/images/flight-deals/Deal4.webp', route: 'New York → London', currentPrice: 283, originalPrice: 730, discount: 66 },
        { image: 'assets/images/flight-deals/Deal5.webp', route: 'Atlanta → Paris', currentPrice: 380, originalPrice: 840, discount: 55 },
        { image: 'assets/images/flight-deals/Deal6.webp', route: 'Houston → Cancun', currentPrice: 161, originalPrice: 550, discount: 71 },
        { image: 'assets/images/flight-deals/Deal7.webp', route: 'Philadelphia → Madrid', currentPrice: 310, originalPrice: 1000, discount: 69 },
        { image: 'assets/images/flight-deals/Deal8.webp', route: 'Seattle → Bali', currentPrice: 646, originalPrice: 1200, discount: 46 },
        { image: 'assets/images/flight-deals/Deal9.webp', route: 'Denver → New York', currentPrice: 59, originalPrice: 350, discount: 71 },
        { image: 'assets/images/flight-deals/Deal10.webp', route: 'Boston → Amsterdam', currentPrice: 289, originalPrice: 815, discount: 64 },
        { image: 'assets/images/flight-deals/Deal12.webp', route: 'San Francisco → Hawaii', currentPrice: 181, originalPrice: 675, discount: 73 },
        { image: 'assets/images/flight-deals/Deal1.webp', route: 'Dallas → Italy', currentPrice: 399, originalPrice: 1210, discount: 67 },
        { image: 'assets/images/flight-deals/Deal2.webp', route: 'Chicago → Greece', currentPrice: 382, originalPrice: 1140, discount: 68 },
        { image: 'assets/images/flight-deals/Deal3.webp', route: 'Los Angeles → Tokyo', currentPrice: 499, originalPrice: 1100, discount: 55 },
        { image: 'assets/images/flight-deals/Deal4.webp', route: 'New York → London', currentPrice: 283, originalPrice: 730, discount: 66 },
        { image: 'assets/images/flight-deals/Deal5.webp', route: 'Atlanta → Paris', currentPrice: 380, originalPrice: 840, discount: 55 },
        { image: 'assets/images/flight-deals/Deal6.webp', route: 'Houston → Cancun', currentPrice: 161, originalPrice: 550, discount: 71 },
        { image: 'assets/images/flight-deals/Deal7.webp', route: 'Philadelphia → Madrid', currentPrice: 310, originalPrice: 1000, discount: 69 },
        { image: 'assets/images/flight-deals/Deal8.webp', route: 'Seattle → Bali', currentPrice: 646, originalPrice: 1200, discount: 46 },
        { image: 'assets/images/flight-deals/Deal9.webp', route: 'Denver → New York', currentPrice: 59, originalPrice: 350, discount: 71 },
        { image: 'assets/images/flight-deals/Deal10.webp', route: 'Boston → Amsterdam', currentPrice: 289, originalPrice: 815, discount: 64 },
        { image: 'assets/images/flight-deals/Deal12.webp', route: 'San Francisco → Hawaii', currentPrice: 181, originalPrice: 675, discount: 73 },
    ];

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        public viewport: ViewportService
    ) {}

    ngOnInit(): void {
        this.updateNumVisible(this.viewport.dimensions.width);
        this.viewport.dimensions$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(dimensions => {
            this.updateNumVisible(dimensions.width);
        });
    }

    updateNumVisible(screenWidth: number) {
        if (screenWidth < 480) {
            this.numVisible = 1.5;
        } else if (screenWidth < 768) {
            this.numVisible = 2.5;
        } else if (screenWidth < 992) {
            this.numVisible = 3.5;
        } else if (screenWidth < 1200) {
            this.numVisible = 4.5;
        } else if (screenWidth < 1400) {
            this.numVisible = 5.5;
        } else {
            this.numVisible = 5.5;
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();

        if (document.activeElement && (document.activeElement as HTMLElement).classList.contains('deal-btn')) {
            (document.activeElement as HTMLElement).blur();
        }
    }
    blurMe(event: MouseEvent) {
        (event.target as HTMLElement).blur();
    }

    redirect(){
        if (document.activeElement && document.activeElement !== document.body) {
            (document.activeElement as HTMLElement).blur();
        }
        document.body.focus();

        setTimeout(() => {
            this.router.navigate([], { relativeTo: this.route, fragment: 'signup-logo', queryParamsHandling: 'preserve' });
        }, 30);
    }

    getResizedImage(image: string, size: number) {
        return image.replace(/\.webp$/, `-${size}-q80.webp`);
    }


}
